import type { ReactNode } from "react";
import { PageContainer } from "@volca/ui/components/ui/page-components";
import { PayBreakdownPaneShell } from "@/payroll/pay-breakdown/pay-breakdown-pane-shell";

export const PacksFrame = ({
  embedded,
  children,
}: {
  embedded: boolean;
  children: ReactNode;
}) =>
  embedded ? (
    <PayBreakdownPaneShell fillHeight gap={6} className="h-full">
      {children}
    </PayBreakdownPaneShell>
  ) : (
    <PageContainer variant="workspace">{children}</PageContainer>
  );
